import { Link } from "react-router-dom";
import { COMPANY_LOGO } from "@/lib/clients";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-background border-t border-border px-6 md:px-12 lg:px-16 py-14"
    >
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
        <div>
          <div className="flex items-center gap-4 mb-5">
            <img
              src={COMPANY_LOGO}
              alt="Jagdambay Engineering Works"
              className="h-16 w-16 object-contain"
            />
            <div className="font-bebas uppercase text-4xl md:text-5xl text-foreground leading-none">
              Jagdambay
              <br />
              <span className="text-primary">Engineering Works</span>
            </div>
          </div>
          <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground max-w-xs">
            Cuplock scaffolding manufacturing, rental & services across India since 1991. Branches in Delhi & Kota.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-10 font-mono text-xs uppercase tracking-widest text-muted-foreground">
          <div className="space-y-2">
            <div className="text-foreground">Contact</div>
            <a href="tel:+919810376040" className="block hover:text-primary transition-colors">98103 76040</a>
            <a href="tel:+919582741576" className="block hover:text-primary transition-colors">95827 41576</a>
            <a href="mailto:jewokhla@gmail.com" className="block hover:text-primary transition-colors">jewokhla@gmail.com</a>
          </div>
          <div className="space-y-2">
            <div className="text-foreground">Offices</div>
            <p className="max-w-[200px] normal-case tracking-normal font-plex">
              63 DSIIDC Complex, Okhla Industrial Area Phase 1, New Delhi 110020
            </p>
            <p className="normal-case tracking-normal font-plex">Branches: Delhi &amp; Kota</p>
          </div>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mt-14 pt-8 border-t border-border font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
        <span>© {new Date().getFullYear()} Jagdambay Engineering Works. All rights reserved.</span>
        <Link
          to="/admin"
          data-testid="admin-link"
          className="hover:text-primary transition-colors"
        >
          Admin
        </Link>
      </div>
    </footer>
  );
};
